import apiClient from "../apiClient";
const resource = "workDaysClosing";
export default {
    getAll: () => apiClient.get(`${resource}`),
    add: payload => apiClient.post(`${resource}`, payload),
    getSummary: (period) => apiClient.get(`${resource}/summary?period=${period}`),
};
